var _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#FFECA9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10080_38220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10080_38220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.9152C42.717 11.8453 45.0002 11.8453 46.8534 12.9152L72.7844 27.8865C74.6376 28.9564 75.7792 30.9337 75.7792 33.0735V63.0161C75.7792 65.1559 74.6376 67.1332 72.7844 68.2032L46.8534 83.1744C45.0002 84.2444 42.717 84.2444 40.8639 83.1744L14.9329 68.2032C13.0797 67.1332 11.9381 65.1559 11.9381 63.0161V33.0735C11.9381 30.9337 13.0797 28.9564 14.9329 27.8865L40.8639 12.9152Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3756 6.58582 9.86812L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#EBAF25"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0371 54.2941C22.0389 64.5882 33.7559 69 44.0099 69C54.5569 69 65.2503 63.8529 65.981 54.2941C66.7116 44.7353 60.1233 34.4412 57.1936 34.4412C54.2639 34.4412 57.1936 39.5882 54.2639 39.5882C53.0816 39.5882 52.6128 36.2351 51.3342 32.2353C49.4445 26.3239 46.631 19 44.0099 19C41.6027 19 38.2978 26.648 36.6857 32.2353C35.3547 36.8482 35.7433 39.5882 33.7559 39.5882C30.8262 39.5882 33.9011 34.4412 30.8262 34.4412C26.4317 34.4412 22.0356 45.451 22.0371 54.2941Z",
    fill: "url(#paint0_linear_10080_38220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6833 54.0303L41.8794 44.6571C42.6942 43.1873 44.8485 43.3168 45.4814 44.8735L46.8632 48.2727H48.7129C50.2206 48.2727 51.1861 49.8776 50.4798 51.2097L45.8577 59.9265C44.97 61.6007 42.4684 61.2165 42.1241 59.353L41.6893 57H38.4326C36.9084 57 35.9444 55.3634 36.6833 54.0303Z",
    fill: "#FFF5D0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10080_38220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 27.5,
    width: 16,
    height: 45,
    rx: 3.5,
    fill: "white",
    stroke: "#FFECA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 41L78.5 37L72 41",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 35L78.5 31L72 35",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47L78.5 43L72 47",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 53L78.5 49L72 53",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 59L78.5 55L72 59",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 65L78.5 61L72 65",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 71L78.5 67L72 71",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 28,
    width: 15,
    height: 44,
    rx: 3,
    stroke: "#FFECA9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10080_38220",
    x1: 44.0371,
    y1: 19,
    x2: 44.0371,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA823E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36565"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10080_38220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27,
    width: 17,
    height: 46,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.01cbec78d8f8c8d271368580801818ec.svg";
export { ForwardRef as ReactComponent };